"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataArray = void 0;

var react_1 = __importStar(require("react"));

var index_1 = require("../../index");

var Condition_1 = __importDefault(require("./Condition"));

var Field_1 = __importDefault(require("./Field"));

var FieldArray_1 = __importDefault(require("./FieldArray"));

exports.DataArray = FieldArray_1.default;

var Section_1 = __importDefault(require("./Section"));

var Tabs_1 = __importDefault(require("./Tabs"));

var WithChildren_1 = __importDefault(require("./WithChildren"));

var Data = function Data(props) {
  var componentType = props.componentType,
      wrapper = props.wrapper,
      wrapperFunc = props.wrapperFunc;
  var datas;
  var name;

  var _ref = (0, react_1.useContext)(index_1.FormidableContext),
      extendData = _ref.extendData;

  var Component = null;

  if (extendData) {
    Component = extendData(props);
  }

  if (!Component) {
    switch (componentType) {
      case 'array':
        {
          name = props.name;

          if (!name) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : name obligatoire"));
          }

          Component = react_1.default.createElement(FieldArray_1.default, _objectSpread(_objectSpread({}, props), {}, {
            name: name
          }));
          break;
        }

      case 'box':
      case 'flex':
      case 'group':
      case 'grid':
        {
          datas = props.datas;

          if (!datas) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : datas obligatoire"));
          } else {
            Component = react_1.default.createElement(WithChildren_1.default, _objectSpread(_objectSpread({}, props), {}, {
              datas: datas
            }));
          }

          break;
        }

      case 'condition':
        {
          var test = props.test;
          datas = props.datas;

          if (!datas) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : datas obligatoire"));
          } else if (!props.formName) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : formName obligatoire"));
          } else if (!test) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : test obligatoire"));
          } else {
            Component = react_1.default.createElement(Condition_1.default, _objectSpread(_objectSpread({}, props), {}, {
              datas: datas,
              test: test
            }));
          }

          break;
        }

      case 'select':
        {
          name = props.name;

          if (!name) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : name obligatoire"));
          } else {
            Component = react_1.default.createElement(Field_1.default, _objectSpread(_objectSpread({}, props), {}, {
              componentType: "select",
              name: name
            }));
          }

          break;
        }

      case 'section':
        {
          datas = props.datas;

          if (!props.name) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : name obligatoire"));
          } else if (!datas) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : datas obligatoire"));
          } else {
            Component = react_1.default.createElement(Section_1.default, _objectSpread(_objectSpread({}, props), {}, {
              datas: datas,
              name: props.name
            }));
          }

          break;
        }

      case 'tabs':
        {
          datas = props.datas;

          if (!datas) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : datas obligatoire"));
          } else {
            Component = react_1.default.createElement(Tabs_1.default, _objectSpread(_objectSpread({}, props), {}, {
              datas: datas
            }));
          }

          break;
        }

      case 'textarea':
        {
          name = props.name;

          if (!name) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : name obligatoire"));
          } else {
            Component = react_1.default.createElement(Field_1.default, _objectSpread(_objectSpread({}, props), {}, {
              componentType: "textarea",
              name: name
            }));
          }

          break;
        }

      case 'hidden':
      case 'input':
        {
          name = props.name;

          if (!name) {
            Component = react_1.default.createElement("div", null, "".concat(componentType, " : erreur de param\xE8tre : name obligatoire"));
          } else {
            Component = react_1.default.createElement(Field_1.default, _objectSpread(_objectSpread({}, props), {}, {
              componentType: componentType,
              name: name
            }));
          }

          break;
        }

      default:
        {
          Component = react_1.default.createElement("div", null, "".concat(componentType, " : ce type de composant n'est pas pris en charge"));
        }
    }
  }

  var Wrapper = wrapper;
  return Wrapper && props.formName && props.position ? react_1.default.createElement(Wrapper, _objectSpread({
    componentType: componentType,
    formName: props.formName,
    name: name,
    position: props.position
  }, wrapperFunc), Component) : Component;
};

exports.default = Data;